const info = {
  ZH: { //中文翻译
    select: '请选择一个报表格式！',
    strong: '材料数据表预览',
    datapreview: '材料数据表预览',
    datatype: '材料数据表类型:',
    ver: 'ID / 版本:',
    orgname: '材料数据表 供应商:',
    mdsname: '供货名称:',
    mdsid: '供货编号:',
    weight: '单个的测量质量:',
    interalcode: '内部材料号:',
    standartion: '标准材料号:',
    materialtype: '物质分类:',
    formark: '报表格式:',
    pdfOld: '下载PDF文件',
    pdf: '下载PDF文件（内部）',
    pdfExternal: '下载PDF文件（外部）',
    page: '浏览页',
    continue: '继续',
    title: '中国汽车材料数据系统',
    title2: '材料数据表预览',
    state: '预览',
    title3: '材料数据表预览',
    maskLayer: '正在处理数据，请稍候...',
  },
  EN: { //英文翻译
    select: 'Please select one report format!',
    strong: 'MDS preview',
    datapreview: 'MDS preview',
    datatype: 'MDS type',
    ver: 'ID/Version:',
    orgname: 'MDS Supplier',
    mdsname: 'Article Name:',
    mdsid: 'Part/Item No.:',
    quality: 'Single measured qulity',
    interalcode: 'Internal Material No.:',
    standartion: 'Standard Material No.:',
    materialtype: 'Substance classification:',
    formark: 'Report format:',
    pdfOld: 'Download PDF file',
    pdf: 'Download PDF file (internal)',
    pdfExternal: 'Download PDF file (external)',
    page: 'Browser Page',
    continue: 'Continue',
    title: 'China Automotive Material Data System (CAMDS)',
    title2: 'MDS preview',
    state: 'MDS',
    title3: 'Preview',
    weight: 'Measured mass per item',
    maskLayer: 'Data is being processed, please wait ...',
  }
}
export default info //需要暴露出去
